import { ApiCall } from 'omni-common-ui';
import { fetch, buildUrl } from 'domain/Api';

export const FETCH_ONLINE_HOMEWORK_CONTENT_REQUEST = 'FETCH_ONLINE_HOMEWORK_CONTENT_REQUEST';
export const FETCH_ONLINE_HOMEWORK_CONTENT_SUCCESS = 'FETCH_ONLINE_HOMEWORK_CONTENT_SUCCESS';
export const FETCH_ONLINE_HOMEWORK_CONTENT_FAILURE = 'FETCH_ONLINE_HOMEWORK_CONTENT_FAILURE';

const buildOnlineHomeworkContentUrl = (sessionId) => buildUrl(`/sessions/${sessionId}/online-homework`);

export function fetchOnlineHomeworkContentIfNeeded(sessionId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildOnlineHomeworkContentUrl(sessionId) })) {
      return false;
    }

    return dispatch(fetchOnlineHomeworkContent(sessionId));
  };
}

export function fetchOnlineHomeworkContent(sessionId) {
  return (dispatch) => {
    const url = buildOnlineHomeworkContentUrl(sessionId);
    const method = 'GET';

    return dispatch(fetchOnlineHomeworkContentRequest()).payload
      .then((response) => dispatch(fetchOnlineHomeworkContentSuccess(response)))
      .catch((error) => dispatch(fetchOnlineHomeworkContentFailure(error)));

    function fetchOnlineHomeworkContentRequest() {
      return ApiCall.createAction({
        type: FETCH_ONLINE_HOMEWORK_CONTENT_REQUEST,
        payload: fetch(url),
        url,
        method,
        sessionId,
      });
    }

    function fetchOnlineHomeworkContentSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_ONLINE_HOMEWORK_CONTENT_SUCCESS,
        payload: response,
        url,
        method,
        sessionId,
      });
    }

    function fetchOnlineHomeworkContentFailure(error) {
      return ApiCall.createAction({
        type: FETCH_ONLINE_HOMEWORK_CONTENT_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/OnlineHomework/Content/actions.js